import React from "react";
import { CardBody } from "reactstrap";
import styles from "./widgetone.module.scss";
import UpImage from "../../../assets/images/status-icons/arrow-up.png";
import DownImage from "../../../assets/images/status-icons/arrow-down.png";

const WidgetsOne = ({ data }) => {
  return (
    <div className={styles["widgetone_card"]}>
      <CardBody className={styles["card_body"]}>
        <div className={styles["content_container"]}>
          <div className={styles["content_image_wrapper"]}>
            <img src={data?.image} alt="" />
          </div>
          <div className={styles["content_text"]}>
            <p className={styles["heading_text"]}>{data?.value}</p>
            <p className={styles["sub_text"]}>{data?.title}</p>
          </div>
          <div className={styles["right_content"]}>
            {data?.deration === "up" ? (
              <>
                <img src={UpImage} alt="" />
              </>
            ) : (
              <>
                <img src={DownImage} alt="" />
              </>
            )}
            <h6
              className={styles["right_content_text"]}
              style={{
                color: data?.deration === "up" ? "#465a7a" : "#FFAA05",
              }}
            >
              {data?.position}
            </h6>
          </div>
        </div>
      </CardBody>
    </div>
  );
};

export default WidgetsOne;
